import { GalleryModal } from '@components/modals/GalleryModal';
import { useModalContext } from '@fourthwall/components';
import { arrayMove } from '@fourthwall/utils/dist/array';
const isImageMatchingFilters = (filters) => (image) => {
    return image.tags.every((tag) => {
        const filter = filters.find((filter) => filter.tag === tag.type);
        return filter ? filter.value === tag.name : true;
    });
};
const getGalleryData = ({ value, filters, }) => {
    return value.filter(isImageMatchingFilters(filters));
};
const mapIndexPosition = (item, index) => {
    return { ...item, position: index };
};
export const useOfferGallery = ({ filters, value, onChange }) => {
    const { open } = useModalContext();
    const galleryData = getGalleryData({ value, filters });
    const handleGalleryView = (item) => {
        open(GalleryModal, {
            images: galleryData,
            selectedImageId: `${item.id}`,
        });
    };
    const handleGalleryRemove = (item) => {
        onChange(value.filter(({ id }) => id !== item.id).map(mapIndexPosition));
    };
    const handleGallerySortChange = (oldIndex, newIndex) => {
        const valueOldIndex = value.findIndex(({ id }) => id === galleryData[oldIndex].id);
        const valueNewIndex = value.findIndex(({ id }) => id === galleryData[newIndex].id);
        onChange(arrayMove(value, valueOldIndex, valueNewIndex).map(mapIndexPosition));
    };
    return {
        data: galleryData,
        onImageView: handleGalleryView,
        onImageRemove: handleGalleryRemove,
        onImagesSort: handleGallerySortChange,
    };
};
